export default {
      id: "ic_info_outline_v2-usage",
      viewBox: "0 0 32 32",
      url: "/" + "images/icons.3.109.2.svg#ic_info_outline_v2-usage",
      toString: function () {
        return this.url;
      }
    }